<template>
  <div>
    <ColourField v-model="colour" :options="colourOptions" :allow-custom="false" />
  </div>
</template>

<script setup lang="ts">
import { ColourField } from '@/components/fields'
import type { Service } from '~/_api/models/service'

interface Colour {
  value: string
  hex: string
}

const service = defineModel<Service>('service')

const colour = computed<string | undefined>({
  get: () => {
    const value = service.value?.colour
    const colours = service.value?.options?.colors
    if (!colours) return undefined
    
    const match = (colours as Colour[]).find((c: Colour) => c.value === value)
    return match?.hex
  },
  set: (value: string | undefined) => {
    if (!value) return
    
    const colours = service.value?.options?.colors
    if (!colours) return

    const match = (colours as Colour[]).find((c: Colour) => c.hex === value)
    if (match && service.value) {
      service.value.colour = match.value
    }
  }
})

const colourOptions = computed(() => {
  const colours = service.value?.options?.colors
  if (!colours) return { options: {} }
  
  const options: Record<string, string> = {}
  
  for (const colour of colours as Colour[]) {
    if (colour?.value && colour?.hex) {
      options[colour.value] = colour.hex
    }
  }
  
  return { options }
})
</script>
